module.exports = __webpack_public_path__ + "img/2w.644f4b65.svg";